import {Component, OnInit} from '@angular/core';
import {SendMailService} from './send-mail.service';

@Component({
    selector: 'app-send-mail',
    templateUrl: './templates/send-mail.component.html',
    styleUrls: ['./styles/send-mail.component.css'],
    providers: [SendMailService]
})
export class SendMailComponent implements OnInit {

    action: string = "demande d'achat";
    url: string = 'purchasing-list;id_transaction_details=';
    date: string;
    name: string;
    reference: string;
    link: string;

    constructor(
        private send_mail_service: SendMailService
    ) {}

    ngOnInit() {

    }

    setValues(action, name, reference, date, id_transaction_details) {
        this.action = action;
        this.name = name;
        this.reference = reference;
        this.date = date;
        this.link = this.url.concat(id_transaction_details);
    }

    sendAnEmail() {
        this.send_mail_service.sendMail(this.action, this.name, this.reference, this.date, this.link).then(result => {
            let r = result;
            console.log(r + ' : email envoyé.');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/send-mail.component.ts